import { Component, OnInit, inject } from "@angular/core";
import { Observable, timer } from "rxjs";

import { RxStompState } from "@stomp/rx-stomp";
import { HttpClient } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { RxStompService } from "@app/services/webstomp/rx-stomp.service";

@Component({
  selector: "app-stomp-status",
  templateUrl: "./stomp-status.component.html",
  styleUrls: ["./stomp-status.component.scss"]
})
export class StompStatusComponent implements OnInit {
  private clientConfigService = inject(ClientConfigService);
  private _stompService = inject(RxStompService);
  private http = inject(HttpClient);

  public state: Observable<RxStompState>;
  lastState: RxStompState = RxStompState.CLOSED;
  currentClass: string = "";
  tooltipText: string = "";

  constructor() {
    this.state = this._stompService.connectionState$;
  }

  private static getClass(state: RxStompState): string {
    switch (state) {
      case RxStompState.CLOSED:
        return "fas fa-circle closed";
      case RxStompState.CONNECTING:
        return "fas fa-circle connecting";
      case RxStompState.CLOSING:
        return "fas fa-circle closed";
      case RxStompState.OPEN:
        return "fat fa-circle open";
    }
  }

  private static getTooltip(state: RxStompState) {
    switch (state) {
      case RxStompState.CLOSED:
        return "No connection to server";
      case RxStompState.CONNECTING:
        return "Attempting to connect";
      case RxStompState.CLOSING:
        return "Connection closing";
      case RxStompState.OPEN:
        return "Connected";
    }
  }

  ngOnInit() {
    // console.log("Status init");

    this._stompService.webSocketErrors$.subscribe(() => {
      // console.log('websocket error ', closeEvent);
      // if (closeEvent.code === 1006) {
      // the reason will be blocked, but it's -probably- http auth or server not available.
      // In either case we can just 'bump' the server to get the credentials re-sent
      this.http
        .get(this.clientConfigService.config.serviceUrl + "/sysInfo", {
          withCredentials: true
        })
        .subscribe(() => {});
    });
    this.state.subscribe((value) => {
      this.currentClass = StompStatusComponent.getClass(value);
      this.lastState = value;
      this.tooltipText = StompStatusComponent.getTooltip(value);
    });
    if (this._stompService.stompClient.webSocket) {
      this._stompService.stompClient.webSocket.onmessage = () => {
        this.currentClass = "fas fa-circle open";
        timer(500).subscribe(() => {
          this.currentClass = StompStatusComponent.getClass(this.lastState);
        });
      };
    }
  }
}
